<!-- The Modal-->
<div class="modal" id="sampleDetailId" *ngIf="sampleTaskDetail">
  <div class="modal-dialog  modal-lg">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-lock"></span>
          Viewing Sample Task Detail
          </h4>
        <button type="button" class="close" (click)="closeSampleTaskModal()">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
       {{sampleTaskDetail}}
   <fieldset class="buttons text-center">

  <button type="button" class="btn btn-danger" (click)="closeSampleTaskModal()">Close</button>
  </fieldset>

</div>
</div>
</div>
</div>

